import { render, staticRenderFns } from "./KYCSettings.vue?vue&type=template&id=0cb3f477&scoped=true&"
import script from "./KYCSettings.vue?vue&type=script&lang=js&"
export * from "./KYCSettings.vue?vue&type=script&lang=js&"
import style0 from "./KYCSettings.vue?vue&type=style&index=0&id=0cb3f477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3f477",
  null
  
)

export default component.exports